import type { InventoryRequestApiStatus } from './inventoryRequestMappers';

interface ResolveInventoryRequestContext {
  status: InventoryRequestApiStatus;
  sourceLocationId: number | null;
  canApprove: boolean;
  canAccessAllLocations: boolean;
  userPrimaryLocationId?: number | null;
}

/** Mirrors backend assertCanResolveAtSource + pending status checks. */
export function canResolveInventoryRequest({
  status,
  sourceLocationId,
  canApprove,
  canAccessAllLocations,
  userPrimaryLocationId,
}: ResolveInventoryRequestContext): boolean {
  if (status !== 'PENDING' || !canApprove) {
    return false;
  }
  if (canAccessAllLocations) {
    return true;
  }
  if (sourceLocationId == null || sourceLocationId <= 0) {
    return false;
  }
  return userPrimaryLocationId === sourceLocationId;
}
